import axios from "axios";

const KEY = "AIzaSyBjByAvRNHW7jg_ABYM_P8YXhRQ8W5oHhw";

export default axios.create({
  baseURL: "https://www.googleapis.com/youtube/v3",
  params: {
    part: "snippet",
    maxResults: 5,
    key: KEY,
  },
});
